module.exports = __webpack_public_path__ + "static/media/email.ba45a104.png";